<template>
  <v-btn
    color="error"
    large
    :to="
      $_getRouteGreatGrandChildDelete(
        role,
        model.key,
        $route.params.id,
        me,
        modelParent.key,
        $route.params.parentId,
        parent,
        modelGrandParent.key,
        grandParent.id,
        grandParent,
        modelGreatGrandParent.key,
        greatGrandParent.id,
        greatGrandParent
      )
    "
  >
    {{ $t("action.delete") }}
  </v-btn>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {
    //
  },
  computed: mapState({
    //
  }),
  props: [
    "me",
    "parent",
    "grandParent",
    "greatGrandParent",
    "role",
    "model",
    "modelParent",
    "modelGrandParent",
    "modelGreatGrandParent",
  ],
  data: () => ({
    //
  }),
  created() {
    //
  },
  mounted() {
    //
  },
  methods: {
    //
  },
};
</script>